// src/components/programs/Table/ProgramsTableColumns.jsx

const ProgramsTableColumns = [
    { id: "program_number", labelAr: "رقم البرنامج", labelEn: "Program #", sortable: true },
    { id: "is_favorite", labelAr: "", labelEn: "", sortable: false },
    { id: "description", labelAr: "اسم العميل", labelEn: "Customer Name", sortable: true },
    { id: "agent", labelAr: "اسم الأيجينت", labelEn: "Agent Name", sortable: false },
    { id: "title_en", labelAr: "اسم البرنامج (إنجليزي)", labelEn: "Program Name (English)", sortable: true },
    { id: "cities", labelAr: "المدن", labelEn: "Cities", sortable: true },
    { id: "durations", labelAr: "المدة", labelEn: "Duration", sortable: true },
    { id: "price", labelAr: "السعر", labelEn: "Price", sortable: true },
    { id: "discount", labelAr: "الخصم", labelEn: "Discount", sortable: false },
    { id: "confirmed", labelAr: "مؤكد", labelEn: "Confirmed", sortable: true },
    { id: "confirmation_number", labelAr: "رقم التأكيد", labelEn: "Confirm #", sortable: true },
    { id: "closed", labelAr: "مغلق", labelEn: "Closed", sortable: true },
    { id: "close_number", labelAr: "رقم الإغلاق", labelEn: "Close #", sortable: true },
    { id: "created_by_user", labelAr: "بواسطة", labelEn: "Created By", sortable: true },
    { id: "updated_at", labelAr: "تاريخ التحديث", labelEn: "Updated At", sortable: true },
];

export default ProgramsTableColumns;
